module.exports = __webpack_public_path__ + "img/qrcode.984bd53b.png";